import 'css-chunksrc/client/scenes/wbsConfiguration/styles.scss';export default {
  "wbsConfiguration": "_wbsConfiguration_pcls1_1",
  "main": "_main_pcls1_8",
  "tabs": "_tabs_pcls1_14",
  "tab": "_tab_pcls1_14",
  "selectedTab": "_selectedTab_pcls1_34",
  "label": "_label_pcls1_41",
  "footer": "_footer_pcls1_48",
  "button": "_button_pcls1_63"
};